import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { UserDTO } from 'BaseDataTypes';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  ComponentSummaryDTO,
  JobIntervalDTO,
  JobIntervalTranslation,
  JobDetailDTO,
  JobSummaryDTO,
  JobStatusDTO,
  JobStatusTranslation,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import {
  dialogData,
  genericDialogComponent,
} from 'projects/Assets/src/assets-base/Dialogs/genericDialog';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from 'src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from 'src/app/buttons/delete-button/delete-button.component';
import { MatInputModule } from '@angular/material/input';
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-job-dialog',
  imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent,
    MatIconModule,
  ],
  templateUrl: './job-dialog.component.html',
  styleUrls: [
    './job-dialog.component.css',
    '../../../../../../src/app/general-styles/dialogs.css',
  ],
})
export class JobDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<JobDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() jobRequest!: JobDetailDTO;

  currentUser = this.userService.currentUser;
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  components: ComponentSummaryDTO[] = [];

  clientCascade(clientId: number) {
    this.jobRequest.clientId = clientId;
    this.jobRequest.plantId = null;
    this.jobRequest.componentId = null;
  }
  plantCascade(plantId: number) {
    this.jobRequest.plantId = plantId;
    this.jobRequest.componentId = null;
  }
  get shownPlants() {
    return this.plants.filter((p) => {
      if (!this.jobRequest.clientId || this.jobRequest.clientId == 0) return true;
      const client = this.clients.find((c) => c.id === this.jobRequest.clientId);
      if (!client) return false;
      return p.clientName === client.name;
    });
  }
  get shownComponents() {
    return this.components.filter((c) => {
      if (!this.jobRequest.plantId) return true;
      const plant = this.plants.find((p) => p.id == this.jobRequest.plantId);
      if (!plant) return false;
      return c.plantName === plant.plantName
    });
  }
  users: UserDTO[] = [];
  intervals = Object.keys(JobIntervalDTO)
    .filter((key) => isNaN(Number(key)))
    .map((name) => ({
      name: JobIntervalTranslation[name as keyof typeof JobIntervalDTO],
      value: name,
    }));
  Statuses = Object.keys(JobStatusDTO)
    .filter((key) => isNaN(Number(key)))
    .map((name) => ({
      name: JobStatusTranslation[name as keyof typeof JobStatusDTO],
      value: name,
    }));
  statusDTO = JobStatusDTO;
  constructor(
    public override dialogRef: MatDialogRef<JobDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.jobRequest = this.data.data[0];
    if (this.jobRequest.plantId == undefined)
      this.jobRequest.plantId = null;

  }

  ngOnInit(): void {
    this.mainService.getAll<ClientSummaryDTO>('Client').subscribe((result) => {
      this.clients = result;
    });

    this.mainService.getAll<PlantSummaryDTO>('Plant').subscribe((result) => {
      this.plants = result;
    });
    this.mainService
      .getAll<ComponentSummaryDTO>('Component')
      .subscribe((result) => {
        this.components = result;
      });
    this.userService.getUserDTOs().subscribe((result) => {
      this.users = result;
    });
  }
  saveChanges() {
    if (this.jobRequest.id == 0) {
      this.mainService
        .add<JobDetailDTO, JobSummaryDTO>('Job', this.jobRequest)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<JobDetailDTO, JobSummaryDTO>('Job', this.jobRequest)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette jobbet?'")) {
      return;
    }
    this.mainService
      .delete('Job', this.jobRequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
